"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TodayStats } from "@/services/dashboardService";
import { Globe, Building2, RefreshCw, CalendarCheck } from "lucide-react";

interface TodayBookingsCardProps {
  stats: TodayStats | null;
  loading: boolean;
}

export function TodayBookingsCard({ stats, loading }: TodayBookingsCardProps) {
  if (loading) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base font-medium">Today's Bookings</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-4 text-muted-foreground">Loading...</div>
        </CardContent>
      </Card>
    );
  }

  if (!stats) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base font-medium">Today's Bookings</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-4 text-muted-foreground">No data available</div>
        </CardContent>
      </Card>
    );
  }

  const bookingTypes = [
    {
      label: "Online",
      value: stats.bookingsByType.online,
      icon: Globe,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      label: "Offline",
      value: stats.bookingsByType.offline,
      icon: Building2,
      color: "text-orange-600",
      bgColor: "bg-orange-50",
    },
    {
      label: "Subscription",
      value: stats.bookingsByType.subscription,
      icon: RefreshCw,
      color: "text-purple-600",
      bgColor: "bg-purple-50",
    },
  ];

  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium">Today's Bookings</CardTitle>
          <div className="flex items-center gap-2">
            <CalendarCheck className="h-5 w-5 text-muted-foreground" />
            <span className="text-2xl font-bold">{stats.totalBookings}</span>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-4">
          {bookingTypes.map((type) => (
            <div key={type.label} className="text-center">
              <div className={`inline-flex items-center justify-center w-10 h-10 rounded-full ${type.bgColor} mb-2`}>
                <type.icon className={`h-5 w-5 ${type.color}`} />
              </div>
              <div className="text-2xl font-bold">{type.value}</div>
              <div className="text-xs text-muted-foreground">{type.label}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
